import React from 'react';

export default function Maps() {
  return (
    <div>
      <h1>Mapas</h1>
    </div>
  );
}
